import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { api, formatDateTime } from '../api';
import { Loading, kundenName } from '../components/ui';
import type { Serviceauftrag } from '../types';

/** Annahmebeleg für den Kunden - über den Browser gedruckt. */
export function ServiceBelegPage() {
  const { id } = useParams();
  const [s, setS] = useState<Serviceauftrag | null>(null);
  useEffect(() => {
    void api<Serviceauftrag>(`/api/service/${id}`).then(setS);
  }, [id]);
  if (!s) return <Loading />;
  const kunde = kundenName({ vorname: s.kunde_vorname, nachname: s.kunde_nachname, firma: s.kunde_firma });
  return (
    <>
      <div className="row nicht-drucken" style={{ marginBottom: 16 }}>
        <Link to={`/service/${s.id}`}>← zurück zum Auftrag</Link>
        <span className="spacer" />
        <button className="primary" onClick={() => window.print()}>
          Drucken
        </button>
      </div>
      <div className="beleg">
        <div className="row" style={{ alignItems: 'flex-start' }}>
          <div>
            <h1 style={{ fontSize: 20 }}>Geräteannahme</h1>
            <div>K&amp;G media Handel und Service GmbH{s.standort ? ` · ${s.standort}` : ''}</div>
          </div>
          <span className="spacer" />
          <div style={{ textAlign: 'right' }}>
            <div className="mono" style={{ fontSize: 22, fontWeight: 700 }}>
              {s.nummer}
            </div>
            <div>{formatDateTime(s.angelegt_am)}</div>
          </div>
        </div>
        <hr />
        <dl className="daten">
          <dt>Kunde</dt>
          <dd>
            {kunde} ({s.kundennummer})
            <br />
            {[s.kunde_strasse, [s.kunde_plz, s.kunde_ort].filter(Boolean).join(' ')].filter(Boolean).join(', ')}
            {s.kunde_telefone?.length ? (
              <>
                <br />
                Tel. {s.kunde_telefone.join(', ')}
              </>
            ) : null}
          </dd>
          <dt>Gerät</dt>
          <dd>{[s.geraeteart, s.marke, s.modell].filter(Boolean).join(' ')}</dd>
          <dt>Seriennummer</dt>
          <dd>{s.seriennummer ?? '—'}</dd>
          <dt>Zubehör</dt>
          <dd>{s.zubehoer ?? 'keines'}</dd>
          <dt>Fehler laut Kunde</dt>
          <dd style={{ whiteSpace: 'pre-wrap' }}>{s.fehlerbeschreibung}</dd>
          {s.wertgarantie && (
            <>
              <dt>Wertgarantie</dt>
              <dd>{s.wertgarantie_nr}</dd>
            </>
          )}
        </dl>
        <p style={{ fontSize: 12, marginTop: 24 }}>
          Bitte bringen Sie diesen Beleg zur Abholung mit. Ist eine Reparatur über den vereinbarten Rahmen hinaus nötig, erhalten Sie vorher einen
          Kostenvoranschlag.
        </p>
        <div className="grid2" style={{ marginTop: 48, gap: 48 }}>
          <div style={{ borderTop: '1px solid #000', paddingTop: 4, fontSize: 12 }}>Unterschrift Kunde</div>
          <div style={{ borderTop: '1px solid #000', paddingTop: 4, fontSize: 12 }}>Angenommen von {s.angelegt_von_name}</div>
        </div>
      </div>
    </>
  );
}
